import { render, staticRenderFns } from "./Researches.vue?vue&type=template&id=17cfee9a&"
import script from "./Researches.vue?vue&type=script&lang=js&"
export * from "./Researches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports